<script>
import { mapState } from 'vuex';

export default {
  name: 'SideBar',
  components: {
  },
  data() {
    return {
      menus: [
        {
          icon: 'el-icon-user',
          title: '个人中心',
          path: '/expert/center',
        },
        {
          icon: 'el-icon-notebook-1',
          title: '比赛管理',
          path: '/expert/compete/projects',
        },
        {
          icon: 'el-icon-notebook-2',
          title: '培训管理',
          path: '/expert/train/activities',
        },
        {
          icon: 'el-icon-bank-card',
          title: '教改项目',
          path: '/expert/research/stages',
        },
      ],
    };
  },
  mounted() {
  },
  computed: {
    ...mapState(['userInfo']),
    avatar() {
      return this.userInfo.avatar;
    },
  },
  methods: {
    onPage(url) {
      this.$router.push(url);
    },
  },
};
</script>

<template lang="pug">
.menu-page
  .header
    img(:src="avatar" v-if="avatar")
    .placeholder(v-else) {{userInfo.name && userInfo.name.charAt(0).toUpperCase()}}
    h3 {{userInfo.name && userInfo.name}}
  .main
    el-menu(:default-active="$route.path")
      el-menu-item(v-for="(menu, index) in menus" :key="index" :index="menu.path" :class="{'active': $route.path === menu.path}" @click.native="onPage(menu.path)")
        i(:class="menu.icon")
        span(slot="title") {{menu.title}}
</template>

<style lang="stylus" scoped>
.menu-page
  width 200px
  height 100%
  background #fff
  text-align center
  overflow auto
  .header
    width 100%
    padding 30px 0px 10px
    background #2B4157
    color #fff
    .placeholder
      width 70px
      height 70px
      font-size 24px
      font-weight 600
      line-height 70px
      color #d3ab78
      background #fff
      border-radius 50%
      margin 0px auto
    img
      width 70px
      height 70px
      border-radius 50%
  .main
    width 100%
    padding-top 20px
    .el-menu
      border none
      .active
        background #2B4157
        color #fff
</style>



// WEBPACK FOOTER //
// SideBar.vue?a58096e6